import React from 'react';
import { Helmet } from 'react-helmet';
import Title from '../../../../components/Title';
import PageNavigation from './PageNavigation';
import { ClientNotificationPriority } from '../ClientNotificationsSubPage/ClientNotificationPriority';
import { Outlet } from 'react-router-dom';

export default function ClientNotificationsSubPage() {
    return (
        <div>
            <Helmet>
                <title>Console Defentry - Settings - Notifications</title>
            </Helmet>
            <Title
                subText="Please fill information for each type of notifications"
                isSubPageTitle
            >
                Notifications settings
            </Title>
            <ClientNotificationPriority />
            <div className="navigation-tabs__bottom-indent-wrapper--24">
                <PageNavigation />
            </div>
            <Outlet />
        </div>
    );
}
